export default "__VITE_ASSET__46fc54ad__"